import axios from "axios";
import { signInWithPhoneNumber } from "firebase/auth";
import {
  refreshTokens,
  setPhoneOTPStatus,
  verifyPhoneNumber,
} from "store/slices/authSlice";
import { setSessionExpiryDialogOpen } from "store/slices/uiSlice";
import { getErrorMessage, getResponseData } from "utils/helpers/httpRequests";
import { toast } from "utils/hooks/useToast";
import http from "utils/httpRequest/http";

export const recoverProfilePassword = (email, setError, setIsSubmitting) => {
  setIsSubmitting(true);
  http
    .post(`/forgot-password`, {
      email,
    })
    .then(() => {
      toast.success("Verification mail sent at your email.");
      setError("");
    })
    .catch((error) => {
      toast.error(error?.response?.data?.message);
      setError(
        error?.response?.data?.message ??
          "Something went wrong. Please try reloading the page."
      );
    })
    .finally(() => {
      setIsSubmitting(false);
    });
};

export const resetProfilePassword = (password, token) => {
  return http.post(`/reset-password?token=${token}`, {
    password,
  });
};

export const getNewAccessToken = async () => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/refresh-tokens`,
      {
        refreshToken: localStorage.getItem("refresh-token"),
      }
    );
    const data = getResponseData(response);
    localStorage.setItem("token", data?.access?.token);
    localStorage.setItem("refresh-token", data?.refresh?.token);
    window?.dispatch(refreshTokens(data));
    return data?.access?.token;
  } catch (error) {
    const message = getErrorMessage(error);
    if (
      error?.response?.data?.data?.code === 401 &&
      error?.response?.data?.data?.message === "jwt expired"
    ) {
      window?.dispatch(setSessionExpiryDialogOpen());
    }
    throw new Error(message);
  }
};

export const sendPhoneOTP = (auth, phoneNumber, setError, setIsSubmitting) => {
  if (window?.recaptchaVerifier) {
    setIsSubmitting(true);
    signInWithPhoneNumber(auth, phoneNumber, window?.recaptchaVerifier)
      .then((confirmationResult) => {
        window.confirmationResult = confirmationResult;
        window?.dispatch(setPhoneOTPStatus(true));
        toast.success("Verification code sent to your phone.");
      })
      .catch((error) => {
        window?.grecaptcha &&
          window?.grecaptcha?.reset(
            window?.recaptchaWidgetId ??
              window?.recaptchaVerifier?.widgetId ??
              ""
          );
        if (error?.message?.includes("auth/too-many-requests")) {
          setError("Too many SMS requests. Please try again later.");
        } else {
          setError("Something went wrong. Please try reloading the page.");
        }
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  }
};

export const verifyPhoneOTP = (phoneOTP, setError, setIsSubmitting) => {
  if (window?.confirmationResult?.confirm) {
    setIsSubmitting(true);
    window?.confirmationResult
      ?.confirm(phoneOTP)
      .then((response) => {
        const token = response?._tokenResponse?.idToken;
        window.dispatch(verifyPhoneNumber(token));
      })
      .catch((error) => {
        if (error?.message?.includes("INVALID_CODE")) {
          return setError("Invalid Verification Code");
        }
        if (error?.message?.includes("auth/invalid-verification-code")) {
          return setError("Invalid Verification Code");
        }
        if (error?.message?.includes("auth/code-expired")) {
          return setError("Verification Code Expired");
        }
        if (error?.message?.includes("SESSION_EXPIRED")) {
          return setError("OTP expired. Request a new OTP.");
        }
        return setError("Verification Code Expired");
      })
      .finally(() => {
        return setIsSubmitting(false);
      });
  } else {
    setError("Session expired. Please resend the phone code.");
  }
};

export const sendEmailOTP = (email, setError, setIsSubmitting) => {
  setIsSubmitting(true);
  http
    .post(`/resend-code`, {
      email,
    })
    .then(() => {
      toast.success("Verification code sent to your email.");
    })
    .catch((error) => {
      toast.error(error?.response?.data?.message);
      setError(
        error?.response?.data?.message ??
          "Something went wrong. Please try reloading the page."
      );
    })
    .finally(() => {
      setIsSubmitting(false);
    });
};

export const uploadFrontCNICImage = (authId = "", image = null, type = "") => {
  const formData = new FormData();
  formData.append(type, image);
  return http.post(`/sellerConfidentialDetail/${authId}`, formData);
};

export const uploadBackCNICImage = (authId = "", image = null, type = "") => {
  const formData = new FormData();
  formData.append(type, image);
  return http.post(`/sellerConfidentialDetail/${authId}`, formData);
};
